/* eslint-disable no-useless-escape */
import { I18n } from 'react-redux-i18n';

const keepOnlyNumber = value => value.replace(/\D/g, '');

const keepAlphanumeric = value => (value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();

const normalizedDocumentLength = (document = '') => keepAlphanumeric(document).length;

const countDecimals = (value) => {
  if (Math.floor(value) === value) return 0;
  return value ? value.toString().split('.')[1].length : 0;
};

function cepMask(cep) {
  const re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;

  if (re.test(cep)) {
    return cep.replace(re, '$1.$2-$3');
  }

  return I18n.t('invalidCep');
}

const validateCep = cep => {
  return /^[0-9]{5}-[0-9]{3}$/.test(cep);
}

const boletoMask = (boleto) => {
  var boletoNumberRegex = /^([\d]{5})([\d]{5})([\d]{5})([\d]{6})([\d]{5})([\d]{6})([\d])([\d]{14})/;
  return boleto.replace(boletoNumberRegex, '$1.$2 $3.$4 $5.$6 $7 $8');
}

const cpfMask = (cpf = '') => {
  const digits = keepOnlyNumber(cpf);
  if (digits.length !== 11) return cpf;
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

const cnpjMask = (cnpj = '') => {
  const raw = keepAlphanumeric(cnpj);
  if (raw.length !== 14) return cnpj;
  return raw.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
}

const cellphoneMask = (celphone = '') => {
  celphone = celphone.replace(/\D/g, '');
  celphone = celphone.replace(/(\d{2})(\d)/, '($1) $2');
  celphone = celphone.replace(/(\d)(\d{4})$/, '$1-$2');

  return celphone
}

const documentMask = (document = '') => {
  const raw = keepAlphanumeric(document);

  if (raw.length <= 11) {
    return cpfMask(raw);
  }

  return cnpjMask(raw);
}

const CPF_INPUT_MASK = '999.999.999-99';
const CNPJ_INPUT_MASK = '**.***.***/****-**';

const taxIdentifierInputMask = (taxIdentifier = '') => (
  normalizedDocumentLength(taxIdentifier) <= 11 ? CPF_INPUT_MASK : CNPJ_INPUT_MASK
);

export default {
  keepOnlyNumber,
  keepAlphanumeric,
  normalizedDocumentLength,
  countDecimals,
  cepMask,
  cpfMask,
  cnpjMask,
  boletoMask,
  cellphoneMask,
  validateCep,
  documentMask,
  CPF_INPUT_MASK,
  CNPJ_INPUT_MASK,
  taxIdentifierInputMask,
};
